import { useRef, useState } from "react";
import { SaveSingleAttribute } from "../../../../services/products/products.service";
import Loading from "../../../../assets/loading.gif";

export const EditableAttribute = ({ articleId, articleVersion, initialValue, attributeData, addNotification, fetchProducts }) => {
  const [currentValue, setCurrentValue] = useState(initialValue || "");
  const originalValue = useRef(initialValue || "");
  const [saving, setSaving] = useState(false);

  const handleSaveAttribute = async (newValue = "") => {
    try {

      setSaving(true);

      const attributeID = attributeData?.id_attribute;
      const attributeName = attributeData?.attribute_name;

      if(!attributeID || !attributeName)
        throw new Error("No se encontro la información necesaria...");

      if(!newValue || newValue.trim() === '')
        throw new Error("Complete el campo solicitado");

      const hasSigns = /[^a-zA-Z0-9\sáéíóúÁÉÍÓÚñÑ]/.test(newValue);

      if(hasSigns)
        throw new Error("El campo no puede contener signos o carácteres especiales");

      const {
        data,
        error
      } = await SaveSingleAttribute({
        articleId: articleId,
        articleVersion: articleVersion,
        attributeId: attributeID,
        attributeName: attributeName,
        newValue: newValue
      })

      if(error) throw new Error(error);

      addNotification("success", `El SKU ${newValue} ha sido guardado correctamente`);
      fetchProducts();
    } catch (error) {
      addNotification("error", error?.message ?? '"Error al guardar el SKU"');
    } finally {
      setSaving(false);
    }
  };

  const handleBlur = () => {
    if (currentValue !== originalValue.current) {

      handleSaveAttribute(currentValue);

      originalValue.current = currentValue;
    }
  };

  return (
    <div className="attribute-container">
      <input
        type="text"
        defaultValue={currentValue || '-'}
        className="attribute-input"
        onChange={(e) => setCurrentValue(e.target.value)}
        onBlur={handleBlur}
      />
      {
        saving ? (
          <img src={Loading} alt="saving" />
        ) : null
      }
    </div>
  );
};